/**
 * The Sayagie brand lockup.
 *
 * The mark is the app's `src/assets/images/logo.png`, copied verbatim so the
 * two clients show the same eight-point star. The wordmark is set in the
 * site's own typeface rather than shipped as artwork, so it stays crisp at
 * any size and inherits the page's font.
 *
 * `size`:
 *   - "header"  inline mark + wordmark for the top bar
 *   - "auth"    stacked mark over wordmark, centred, for the auth screens
 *   - "mark"    the star on its own, no wordmark — the app's Get Started
 *               footer sets the name as "By Sayaty Enterprise" underneath,
 *               so a second wordmark there would read twice.
 */

import "./style.css";

const MARK_SRC = "/assets/logo/sayagie-mark.png";

const SayagieLogo = ({ size = "header", className = "", tagline = false }) => (
  <span className={`sayagie-logo sayagie-logo--${size} ${className}`.trim()}>
    <img
      className="sayagie-logo-mark"
      src={MARK_SRC}
      alt={size === "mark" ? "Sayagie" : ""}
      aria-hidden={size === "mark" ? undefined : true}
    />
    {size !== "mark" && <span className="sayagie-logo-word">Sayagie</span>}
    {tagline && <span className="sayagie-logo-tagline">Energy, Simplified</span>}
  </span>
);

export default SayagieLogo;
